export default __webpack_public_path__ + "static/media/3.236dfd13.png";